"use client";

import AppImage from "@/components/ui/AppImage";
import Icon from "@/components/ui/AppIcon";

const officePhotos = [
{
  src: "/assets/images/07d0ad84-357a-4080-9674-181f0266e9ef-1772186165441.jpg",
  alt: "PC CARGO LIMITED office reception area with company signage on wall and professional front desk",
  caption: "觀塘海濱道139號",
  captionSub: "香港辦公室接待區"
},
{
  src: "/assets/images/bd9b41da-6756-4486-81c2-7ad5c8278527-1772186555714.jpg",
  alt: "PC CARGO LIMITED office interior with desks, computers, office chairs, windows with city view and professional workspace",
  caption: "辦公室內部環境",
  captionSub: "專業貿易辦公空間"
},
{
  src: "/assets/images/IMG_2406-1772189199216.jpg",
  alt: "PC CARGO team members in conference room discussion with bookshelf background",
  caption: "專業貿易團隊",
  captionSub: "24小時報價支援"
}];


const warehousePhotos = [
{
  src: "/assets/images/IMG_3031-1772187204044.jpg",
  alt: "Warehouse shelving system with GPU boxes and computer parts inventory with green labels on metal shelving units",
  caption: "倉庫貨架系統",
  captionSub: "500+ SKU 整齊存放"
},
{
  src: "/assets/images/IMG_3033-1772187343039.jpg",
  alt: "Warehouse shelving units stocked with MSI PRO Z790 motherboard boxes and computer parts inventory",
  caption: "庫存管理系統",
  captionSub: "即時庫存追蹤"
},
{
  src: "/assets/images/IMG_3023-1772187461526.jpg",
  alt: "Taiwan partner warehouse with large inventory storage area, stacked cardboard boxes, green flooring, and loading area",
  caption: "台灣合作倉庫",
  captionSub: "直接對接原廠供應鏈"
}];


export default function OfficeWarehouseSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-8xl mx-auto px-6 md:px-10">
        {/* Office Section */}
        <div className="mb-20">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-xl bg-orange/10 flex items-center justify-center">
              <Icon name="BuildingOfficeIcon" size={20} className="text-orange" />
            </div>
            <span className="text-xs font-black text-orange uppercase tracking-widest">辦公室 · Office</span>
          </div>
          <h2 className="font-heading font-black text-3xl md:text-4xl text-navy mb-2">
            觀塘海濱道139號
          </h2>
          <p className="text-text-muted text-base mb-10 max-w-2xl">
            位於香港觀塘核心商業區，毗鄰維多利亞港，交通便利，是香港科技貿易的重要樞紐。
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {officePhotos.map((photo, i) =>
            <div key={i} className="group overflow-hidden rounded-3xl shadow-lg border border-navy-100">
                <div className="relative h-56 overflow-hidden">
                  <AppImage
                  src={photo.src}
                  alt={photo.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                
                  <div className="absolute inset-0 bg-gradient-to-t from-navy/70 via-transparent to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <div className="text-white font-bold text-sm">{photo.caption}</div>
                    <div className="text-white/70 text-xs">{photo.captionSub}</div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Address card */}
          <div className="mt-8 flex flex-wrap gap-4">
            <div className="flex items-center gap-3 bg-navy-50 border border-navy-100 rounded-2xl px-5 py-3">
              <Icon name="MapPinIcon" size={18} className="text-orange" />
              <div>
                <div className="text-navy font-bold text-sm">香港觀塘海濱道139號</div>
                <div className="text-text-muted text-xs">139 Hoi Bun Road, Kwun Tong, Hong Kong</div>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-navy-50 border border-navy-100 rounded-2xl px-5 py-3">
              <Icon name="ClockIcon" size={18} className="text-orange" />
              <div>
                <div className="text-navy font-bold text-sm">辦公時間</div>
                <div className="text-text-muted text-xs">週一至週五 09:00–18:00 HKT</div>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-navy-100 mb-20" />

        {/* Warehouse Section */}
        <div>
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-xl bg-orange/10 flex items-center justify-center">
              <Icon name="ArchiveBoxIcon" size={20} className="text-orange" />
            </div>
            <span className="text-xs font-black text-orange uppercase tracking-widest">倉庫設施 · Warehouse</span>
          </div>
          <h2 className="font-heading font-black text-3xl md:text-4xl text-navy mb-2">
            專業倉儲管理
          </h2>
          <p className="text-text-muted text-base mb-10 max-w-2xl">
            香港及台灣雙倉庫運作，確保庫存充足、出貨迅速。所有產品均按品牌、型號分類存放，
            配備條碼庫存管理系統，實時掌握庫存狀況。
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {warehousePhotos.map((photo, i) =>
            <div key={i} className="group overflow-hidden rounded-3xl shadow-lg border border-navy-100">
                <div className="relative h-56 overflow-hidden">
                  <AppImage
                  src={photo.src}
                  alt={photo.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                
                  <div className="absolute inset-0 bg-gradient-to-t from-navy/70 via-transparent to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <div className="text-white font-bold text-sm">{photo.caption}</div>
                    <div className="text-white/70 text-xs">{photo.captionSub}</div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Warehouse features */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
            {[
            { icon: "CubeIcon", label: "500+ SKU", sub: "產品種類" },
            { icon: "BoltIcon", label: "24小時", sub: "快速出貨" },
            { icon: "ShieldCheckIcon", label: "防偽驗證", sub: "正品保證" },
            { icon: "ChartBarIcon", label: "即時庫存", sub: "條碼管理" }].
            map((feat) =>
            <div key={feat.label} className="bg-navy-50 border border-navy-100 rounded-2xl p-4 text-center">
                <Icon name={feat.icon as "CubeIcon"} size={24} className="text-orange mx-auto mb-2" />
                <div className="font-heading font-black text-xl text-navy">{feat.label}</div>
                <div className="text-xs text-text-muted mt-1">{feat.sub}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

}